const byArrivalSequence = (a, b) => Number(a.id) - Number(b.id);

const mergeMessages = (state, incoming) => {
  const byId = new Map(state.map(message => [message.id, message]));
  incoming.forEach(message => byId.set(message.id, message));
  return Array.from(byId.values()).sort(byArrivalSequence);
};

const messagesReducer = (state, action) => {
  if (action.type === "LOAD_MESSAGES") {
    return mergeMessages(state, action.payload);
  }

  if (action.type === "ADD_MESSAGE") {
    return mergeMessages(state, [action.payload]);
  }

  if (action.type === "UPDATE_MESSAGE") {
    return state.some(message => message.id === action.payload.id)
      ? mergeMessages(state, [action.payload])
      : state;
  }

  if (action.type === "RESET") {
    return [];
  }

  return state;
};

export default messagesReducer;
